<!-- <ngx-ui-loader ></ngx-ui-loader> -->
<div class="popup-bg popup-all-cards " *ngIf="totalRecord && totalRecord.length  > 0">
    <div class="popup popup-wide">
        <div class="popup-content">
            <h3>All KPI’s</h3>
            <a href="javascript:void(0)" class="close" (click)="forPopupClose()">
                <img src="assets/images/close-light-icon.svg" alt="">
            </a>
        </div>
        <div class="all-cards">
            <div class="input-row input-row-wide">
                <div class="input-wrap">
                    <span class="input-title">Date</span>
                    <div class="dropdown-wrap calendar-light">
                        <form>
                            <my-date-range-picker (ngModelChange)="filterData($event)" name="mydaterange" [options]="myDateRangePickerOptions" [(ngModel)]="model" required>
                            </my-date-range-picker>
                        </form>
                    </div>
                </div>
            </div>
            <ng-scrollbar *ngIf="dragDropArray && dragDropArray.length>0">
                <div class="allcard-wrap">
                    <!-- <div class="cards-wrapper  clearfix"  >
                    <div class="media-card-wrap"   (dragleave)="allowDrop($event,i)"*ngFor = "let list of cardData;let i=index;" >
                        <div draggable="true" (dragstart)="drag($event,i)">
                          

                           <app-card-component [listData]="list" [index]="i+1" [appName]="appName" [typeOfComm]="typeOfComm"
                           [order_id]="order_id"  [cardName]="cardName" (valueChange)="valueChangeEvent($event)"></app-card-component>
                        </div>
                    </div>
                </div> -->

                    <div cdkDropListGroup>
                        <ul>
                            <li *ngFor="let cardArray of dragDropArray;let cardArrayIndex=index;">
                                <div class="example-container" id="container{{cardArrayIndex}}">
                                    <div class="kpi-card-wrap">
                                        <div cdkDropList [cdkDropListData]="cardArray['arr']" class="example-list" (cdkDropListDropped)="drop($event)" id="dropList{{cardArrayIndex}}">
                                            <ng-container *ngFor="let list  of cardArray['arr'];let i=index;">
                                                <div class="example-box" cdkDrag [ngClass]="{'card-down':i==(cardArray['arr'].length-1)}">
                                                    <app-card-component style="width: 100%;" [pageTab]="cardArrayIndex" [listData]="list" [units]="unitscards" [index]="i+1" [cardName]="cardName" (valueChange)="valueChangeEvent($event)">
                                                    </app-card-component>
                                                </div>
                                                <ng-container *ngIf="isResulSearched && (i==0)">
                                                    <span class="search-results-tag">{{(cardArrayIndex==0)?'Search Results:':''}}</span>

                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <!-- <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
    <div class="example-box" *ngFor="let movie of movies" cdkDrag>{{movie}}</div>
  </div> -->



                    <!-- <div class="example-container">
                    <h2>Done</h2>
                  
                    <div
                      cdkDropList
                      #doneList="cdkDropList"
                      [cdkDropListData]="done"
                      [cdkDropListConnectedTo]="[todoList]"
                      class="example-list"
                      (cdkDropListDropped)="drop($event)">
                      <div class="example-box" *ngFor="let item of done" cdkDrag>{{item}}</div>
                    </div>
                  </div> -->
                </div>
            </ng-scrollbar>
        </div>
    </div>